import React, { useEffect, useMemo, useState, useCallback } from "react";
import "../style.scss";
import axios from 'util/axios';
import { useDispatch, useSelector } from "react-redux";


import SearchableSelect from "util/component/SearchableSelect";

import { useTranslation } from "react-i18next";

import { getURLParam } from "util";

import Preview from "pages/PCSGenerator/preview";

const Main = () => {
    const [Projects, SetProjects] = useState([]);
    const [Sheets, SetSheets] = useState([]);

    const [equis, setEquis] = useState([]);

    const [RevInfo, SetRevInfo] = useState(null);

    const { t } = useTranslation(["page"]);

    const userSelector = useSelector((store) => store.user);
    const dispatch = useDispatch();

    const [PDFInfo, setPDFInfo] = useState(false);

    const getSheets = useCallback(
        async (url, setState) => {
            dispatch({ type: "LOADING_ON" });
            const params = getURLParam();
            try {
                const response = await axios.post(process.env.REACT_APP_API + url, {
                    projectNm: params.projectNm,
                    processCd: params.processCd,
                });

                const data = response?.data.data.result;

                if (url.match("retrieveGenerateTemplateList")) {

                    const code = data[0]?.geneCode;

                    const response2 = await axios
                        .post(process.env.REACT_APP_API + "/pcsReview/retrieveReviewRound", { geneCode: code })
                        .catch((error) => console.error(error));

                    const reviewEnd = response2.data.data.result?.reviewEnd;
                    SetRevInfo({
                        geneCode: code,
                        revision: response?.data.data.revision,
                        tempYn: response?.data.data.tempYn,
                        reviewEnd: reviewEnd,
                        userId: response2?.data.data.result?.userId,
                        userNm: response2?.data.data.result?.userNm
                    });
                }
                setEquis(response?.data.data.revisionList);
                setState(data);
            } catch (e) {
                console.error(e);
            }
            dispatch({ type: "LOADING_OFF" });
        },
        [Projects, dispatch]
    );

    useEffect(() => {

        const params = getURLParam();

        SetProjects(params);
        SetSheets([]);
        SetRevInfo(null);

    }, []);

    useEffect(() => {
        getSheets("/pcsGenerate/retrieveGenerateTemplateList", SetSheets);

    }, []);

    const projRender = useMemo(() => {
        return <tr
            className={"text-center"}
        >
            <td>{Projects.projectNm}</td>
            <td>{Projects.processCd}</td>
        </tr>

    }, [Projects]);

    const equisRender = useMemo(() => {
        if (RevInfo?.revision && RevInfo?.tempYn) {
            const options = [];
            let value;
            for (let i = 0; i < RevInfo.revision.maxRevision; i++) {
                options.push({rev: i + 1,val:i + 1});
            }

            const tempYn = RevInfo.tempYn;
            if (tempYn !== "N") {
                value =  RevInfo.selected?.label || RevInfo.revision.maxRevision + "T";
                options.push({
                    rev: RevInfo.revision.maxRevision,
                    val: RevInfo.revision.maxRevision + "T",
                    temp: "Y",
                });
            } else {
                value = RevInfo.selected?.label || RevInfo.revision.maxRevision;
            }
             return options?.map((data, index) => {
                 const equisData = equis.find(d=> d.revision===data.rev && data.temp !== "Y")
                   return(
                       <tr key={"equisData_" + index}
                           className={"text-center" + (data.val === value ? " selected" : "")}>
                           <td onClick={() => RevChange({label: data.rev, value: data.rev, temp: data.temp})}
                               style={{cursor: "pointer"}}>
                               {data.rev} {data.temp === "Y" ? <sup className="temp">Temp</sup> : ""}
                           </td>
                           <td>{equisData?.veevaDocNo}</td>
                           <td>{equisData?.veevaDocMajorVersion}{equisData?.veevaDocMinorVersion || equisData?.veevaDocMajorVersion ? "." : ""}{equisData?.veevaDocMinorVersion}</td>
                           <td>{equisData?.veevaDocApprovedDate}</td>
                           <td>{equisData?.veevaDocStatus}</td>
                       </tr>
                   )
             });
        }
    }, [RevInfo]);

    const sheetRender = useMemo(() => {
        if (!Sheets) return null;
        try {
            return Sheets?.map((data, index) => {

                if (data.templateType !== "DESC") {
                    return (

                        <tr key={"sheets_" + index}>
                            <td className={"text-center"}>{data.projectNm}</td>
                            <td className={"text-center"}>{data.templateNm}</td>
                            <td className={"text-center"}>{data.processCd}</td>
                            <td title={data.description}>{data.description}</td>

                            <td
                                className={
                                    "text-center "
                                }
                                style={{ overflow: "initial" }}
                            >
                                {data.templateRevision}{data.templateTemp === "Y" && <span className={`bpl-temp-v2`}></span>}
                            </td>

                        </tr>
                    );
                } else {
                    return null;
                }
            });
        } catch (e) {
            console.error(e.message);
            return null;
        }
    }, [Sheets, getSheets]);


    const SelectRender = useMemo(() => {
        let tempRow;
        try {
            tempRow = Sheets?.find((f) => f.templateType === "DESC");

            return (
                <td
                    style={{
                        textAlign: "center",
                        overflow: "initial",
                    }}
                >
                    {tempRow?.templateRevision}{tempRow?.templateTemp === "Y" && <span className="bpl-temp-v2"></span>}
                </td>
            );
        } catch (e) {
            return (
                <td
                    className={
                        tempRow?.maxRevision > tempRow?.templateRevision ? "low-revision-warn" : ""
                    }
                    style={{
                        textAlign: "center",
                        overflow: "initial",
                    }}
                ></td>
            );
        }
    }, [Sheets]);

    const previewFunc = async () => {
        const { revision, tempYn, selected } = RevInfo;

        const ds = Sheets.find((f) => f.templateType === "DESC");
        const sheets = Sheets.filter((f) => f.templateType === "SHEET");
        const sheetList = sheets.map((s) => {
            return {
                sheetCode: s.templateCode,
                revision: s.templateRevision,
                tempYn: s.templateTemp || "N",
            };
        });

        const revInfo = {
            revision: selected ? selected.value : revision.maxRevision,
            tempYn: selected ? 'N' : tempYn,
            ...Projects
        }

        const DS_DATA = {
            descCode: ds.templateCode,
            revision: ds.templateRevision,
            tempYn: ds.templateTemp || "N",
            sheetList: sheetList,
            userId: userSelector?.userId,
            revInfo: revInfo
        };

        const BASE64_ENCODED = btoa(JSON.stringify(DS_DATA));
        window.open("/PCSGeneratorPreview?data=" + encodeURIComponent(BASE64_ENCODED), "_blank");
    };

    const PDFDownFunction = async () => {
        const uri = '/pcsGenerate/retrieveGenerateTemplateForSave';
        const { geneCode, revision, tempYn, selected } = RevInfo;
        const postData = {
            "geneCode": geneCode,
            revision: selected ? selected.value : revision.maxRevision,
            tempYn: selected ? 'N' : tempYn,
            ...Projects
        }
        const response = await axios.post(process.env.REACT_APP_API + uri, postData);
        const data = response.data.data;

        setPDFInfo({ ...data, revInfo: postData });
    }

    const PDFFunction = (data) => {
        setPDFInfo(false);
    }

    const getSheetsByGeneCode = async (geneCode, revision, tempYn) => {
        dispatch({ type: "LOADING_ON" });
        if (tempYn === "Y") {
            await getSheets("/pcsGenerate/retrieveGenerateTemplateList", SetSheets);
        } else {
            const response = await axios.post(
                process.env.REACT_APP_API + "/pcsGenerate/retrieveGenerateTemplateListByRevision",
                {
                    geneCode,
                    revision,
                }
            );

            const result = response?.data.data.result;
            SetSheets(result);
        }
        dispatch({ type: "LOADING_OFF" });
    };

    const RevChange = (selected) => {
        const revision = selected.value.toString().replaceAll(/\D/g, "");
        const code = Sheets.find((f) => f.templateType === "DESC").geneCode;
        SetRevInfo((OLD) => ({ ...OLD, selected: selected }));
        getSheetsByGeneCode(code, revision, selected.temp || "N");
    };

/*    const RevisionSelector = useMemo(() => {
        if (RevInfo?.revision && RevInfo?.tempYn) {
            const options = [];
            for (let i = 0; i < RevInfo.revision.maxRevision; i++) {
                options.push({ label: i + 1, value: i + 1 });
            }

            const tempYn = RevInfo.tempYn;
            let value;
            if (tempYn !== "N") {
                value = RevInfo.selected || RevInfo.revision.maxRevision + "T";
                options.push({
                    label: RevInfo.revision.maxRevision,
                    value: RevInfo.revision.maxRevision + "T",
                    temp: "Y",
                });
            } else {
                value = RevInfo.selected || RevInfo.revision.maxRevision;
            }
            return (
                <SearchableSelect
                    search={false}
                    border={"ON"}
                    options={options}
                    value={value}
                    height={"33px"}
                    onChange={RevChange}
                    revision={true}
                />
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [RevInfo]);*/

    const RenderBtns = useMemo(() => {
        try {

            if (Sheets.toString() !== "ERR104") {
                return (
                    <div className="button-box">
                        {/*<div style={{ width: "100px", height: "40px" }}>{RevisionSelector}</div>*/}
                        <button className={"bpl-btn success"} onClick={previewFunc}>
                            {t("preview")}
                        </button>
                        <button className={"bpl-btn success"} onClick={PDFDownFunction}>
                            {`PDF Download`}
                        </button>
                    </div>
                );
            } else return null;
        } catch (e) {
            return null;
        }
    }, [Sheets, RevInfo]);

    return (
        <section className={"PCSView"}>
            <h3 className="title">PCS View</h3>
            <div className="main-container">
                <div className="left">
                    <table className="bpl-table-default proj-table" style={{width: "auto"}}>
                        <colgroup>
                            <col width="120px"/>
                            <col width="130px"/>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>Project</th>
                            <th>Process</th>
                        </tr>
                        </thead>
                        <tbody>{projRender}</tbody>
                    </table>
                </div>
                <div className="right">{RenderBtns}</div>


                <div className={"content-area"}>


                    {Sheets.toString() === "ERR104" && (
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                textAlign: "center",
                            }}
                        >
                            {t(Sheets)}
                        </div>
                    )}
                    <>
                        <div className="left">
                            <><h5 className={"section-title"}>Revision History</h5>
                                <div>
                                <table className="bpl-table-default compact-row fixed sheet-table"
                                           style={{width: "auto"}}>
                                        <colgroup>
                                            <col width="120"/>
                                            <col width="130px"/>
                                            <col width="100px"/>
                                            <col width="100px"/>
                                            <col width="130px"/>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>Revision</th>
                                            <th>PCS No.</th>
                                            <th>EQUIS Version</th>
                                            <th>Approved Date</th>
                                            <th>PCS Status in EQUIS</th>
                                        </tr>
                                        </thead>
                                        <tbody>{equisRender}</tbody>
                                    </table>
                                </div>
                            </>
                        </div>
                        <div className={"right"}>
                            <h5 className={"section-title"}>MBR Sheet List</h5>
                            {
                                Sheets.toString() !== "ERR104" && (
                                    <div>
                                        <table className="bpl-table-default compact-row fixed sheet-table">
                                            <colgroup>
                                                <col width="80px"/>
                                                <col width="80px"/>
                                                <col width="80px"/>
                                                <col/>
                                                <col width="80px"/>
                                                <col width="30px"/>
                                            </colgroup>
                                            <thead>
                                            <tr>
                                                <th>Project</th>
                                                <th>MBR No.</th>
                                                <th>Process</th>
                                                <th>Desc.</th>
                                                <th>Rev.</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td colSpan="4">Description Header</td>
                                                {SelectRender}
                                            </tr>
                                            <tr>
                                                <td colSpan="4">Description Common</td>
                                                {SelectRender}
                                            </tr>
                                            {sheetRender}
                                            <tr>
                                                <td colSpan="4">Description Footer</td>
                                                {SelectRender}
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                        </div>
                    </>

                </div>
            </div>
            {PDFInfo && (<div style={{
                display: "none",
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 100,
                backgroundColor: "#FFF",
                width: "100%",
                height: "100%",
                overflow: "auto"
            }}>

                <Preview docData={PDFInfo} func={PDFFunction}/>
            </div>)}
        </section>
    );
};

export default Main;
